module.exports = __webpack_public_path__ + "img/part1-1.d9e280a2.png";